/* tslint:disable */

declare var Object: any;
export interface SFSpt1721A1Interface {
  "id"?: number;
}

export class SFSpt1721A1 implements SFSpt1721A1Interface {
  "id": number;
  constructor(data?: SFSpt1721A1Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFSpt1721A1`.
   */
  public static getModelName() {
    return "SFSpt1721A1";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFSpt1721A1 for dynamic purposes.
  **/
  public static factory(data: SFSpt1721A1Interface): SFSpt1721A1{
    return new SFSpt1721A1(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFSpt1721A1',
      plural: 'SFSpt1721A1s',
      path: 'SFSpt1721A1s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFSpt1721A1.ts